// ---------- THIS FILE IS AUTO GENERATED -----------------//
/* eslint-disable max-len */

export enum GeneralLedgerAccountClassification {
  Unknown = 0,
  Main = 100,
  Sub = 200
}

export enum GeneralLedgerAccountType {
  Unknown = 0,
  Asset = 100,
  Liability = 200
}

export enum GeneralLedgerAccountStatus {
  Unknown = 0,
  Pending = 100,
  Active = 200
}

export enum GeneralLedgerAccountSpecialConfig {
  Unknown = 0,
  CheckDisbursement = 200,
  DdaDisbursement = 300
}

export enum JournalEntryTransactionType {
  Unknown = 0,
  Credit = 1,
  Debit = 2
}

export enum PreliminaryJournalType {
  Unknown = 0,
  BankTransactionCreated = 10,
  BankTransactionCanceled = 20,
  PaymentExported = 30,
  PaymentUnexported = 40,
  ExportValidationCount = 50,
  CancelValidationCount = 60
}

export enum PaymentMethod {
  Unknown = 0,
  AchCredit = 1,
  ReverseWire = 2,
  Check = 3,
  DirectWireDebit = 4,
  AchDebit = 5,
  DirectWireCredit = 6
}

export enum StatusCode {
  Inactive = 0,
  Active = 1,
  Pending = 2
}

export enum WriteLogEventLevel {
  Critical = 1,
  Error = 2,
  Warning = 4,
  Information = 8,
  Verbose = 16
}

export enum AckStatus {
  All = 0,
  Ack = 1,
  UnAck = 2
}

export enum EmployeeAlertDetailsAccountType {
  Unknown = 0,
  Checking = 1,
  Savings = 2,
  DebitCard = 3
}

export enum PriorQuarterQrfProcessingStatus {
  Unknown = 0,
  Created = 100,
  InProgress = 200,
  ObjectStoreReadFailed = 300,
  ObjectStoreSaveFailed = 400,
  ProcessingCompleted = 500,
  ProcessingFailed = 600,
  ValidationFailed = 700
}

export enum BankNotificationCodeType {
  Unknown = 0,
  Return = 10,
  Rejection = 15,
  NotificationOfChange = 20,
  CheckCancellation = 30,
  DirectDepositCancellation = 35,
  CheckUndoCancellation = 40,
  DirectDepositUndoCancellation = 45
}

export enum BankTransactionType {
  Unknown = 0,
  DirectDeposit = 1,
  Check = 2,
  Collection = 3,
  RefundCollection = 4,
  DirectWireCollection = 5,
  Refund = 6,
  DirectWireOverpay = 7,
  ConsolidatedDirectDeposit = 11,
  ConsolidatedAchDebit = 12,
  PrenoteDirectDeposit = 13,
  ConsolidatedNettedAchDebit = 14,
  NetCollection = 15,
  NetRefundCollection = 16,
  NetAchReversalCredit = 17,
  NetAchReversalDebit = 18,
  ManualCredit = 50,
  ManualDebit = 55,
  AchReversalCredit = 169,
  PostingErrorCorrectionCredit = 254,
  ZbaCredit = 275,
  ZbaCreditTransfer = 277,
  ControlledDisbursementCredit = 281,
  AchReversalDebit = 469,
  AchReturnCredit = 480,
  TaxWirePayment = 495,
  PostingErrorCorrectionDebit = 554,
  ZbaDebit = 575,
  ZbaDebitTransfer = 577,
  ControlledDisbursementDebit = 581,
  ControlledDisbursementFundingDebit = 738,
  ControlledDisbursementFundingCredit = 739,
  TaxCheck = 802,
  TaxEft = 811,
  GarnishmentCheck = 1051,
  GarnishmentEft = 1052,
  UnsuccessfulRefund = 1100
}

export enum BankTransactionRejectionType {
  Unknown = 0,
  Return = 10,
  Rejection = 15,
  NotificationOfChange = 20
}

export enum CollectionRequestStatus {
  Unknown = 0,
  Created = 10,
  Generated = 20,
  Generating = 30,
  SetInTransit = 40,
  ProcessingFailure = 45
}

export enum ProductActivationChangeType {
  Activation = 100,
  Deactivation = 200,
  Unknown = -1
}

export enum CompanyStatusCode {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Pending = 3
}

export enum FeinType {
  Unknown = 0,
  Registered = 1,
  AppliedFor = 2,
  CommonPayAgent = 3
}

export enum CompanyActivationStatus {
  Unknown = 0,
  Activated = 30,
  DatabaseExceptionCheckingOpenPayrolls = 200,
  DatabaseExceptionCheckingConflictingPays = 210,
  DataSyncUnavailable = 250,
  HasOpenPayrolls = 350,
  HasConflictingPays = 360,
  ProductChangesSuccessful = 375,
  SavingCheckNumbersFailed = 400,
  TenantNotFound = 550,
  UpdatingCompanySettingsFailed = 600,
  ValidForPending = 650
}

export enum BankAccountType {
  Unknown = 0,
  Checking = 1,
  Saving = 2
}

export enum BankAccountStatus {
  Active = 1,
  Inactive = 2,
  Pending = 3
}

export enum VerificationStatus {
  Unknown = 0,
  Pending = 10,
  Requested = 20,
  Verified = 30,
  Collected = 40,
  Voided = 50
}

export enum CustomerNotificationCategory {
  Unknown = 0,
  BankNotificationPay = 1
}

export enum CustomerNotificationType {
  Unknown = 0,
  BankNotificationPayReturn = 11,
  BankNotificationPayRejection = 12,
  BankNotificationPayNoc = 13,
  BankNotificationPayUndoNoc = 14,
  BankNotificationPayUndoReturn = 15,
  BankNotificationPayUndoRejection = 16
}

export enum EmployeeDdPrenoteSyncStatus {
  Unknown = 0,
  Failed = 100,
  Success = 200,
  Syncing = 300
}

export enum FileProcessingStatus {
  Unknown = 0,
  Failed = 5,
  NoFileNeeded = 7,
  Requested = 10,
  Processing = 15,
  Generated = 20
}

export enum InboundFileStatus {
  Unknown = 0,
  Created = 10,
  ProcessFailure = 20,
  ValidationFailure = 30,
  FailedUpload = 40,
  ProcessConflict = 50,
  ValidationSuccess = 60,
  SuccessfulUpload = 70,
  Processed = 100
}

export enum InboundFileType {
  Unknown = 0,
  Bai2 = 10,
  ReceivableManager = 20,
  NachaReturnItem = 30
}

export enum LiabilityType {
  Unknown = 0,
  Adjustment = 100,
  CancellationRefund = 150,
  DeletedRefund = 170,
  NotPayableRefund = 175,
  ReversedRefund = 180,
  TaxRefund = 185,
  Refund = 200,
  Recollect = 250,
  Liability = 300,
  Garnishments = 325,
  TaxFiling = 350,
  TaxPenaltyInterest = 360,
  Variance = 400
}

export enum LiabilityStatus {
  Unknown = 0,
  Assembling = 1,
  Assembled = 2,
  Collected = 10,
  CollectionCreated = 20,
  InTransit = 30,
  OnHold = 40,
  PartiallyCollected = 43,
  Pending = 45,
  Ready = 50,
  Returned = 60,
  Voided = 70
}

export enum CollectionStatus {
  Unknown = 0,
  Collected = 10,
  Combined = 15,
  Created = 20,
  InTransit = 30,
  OnHold = 40,
  PartiallyCollected = 43,
  Pending = 45,
  Ready = 50,
  Returned = 60,
  Voided = 70
}

export enum CollectionType {
  Unknown = 0,
  CancellationRefund = 50,
  DeletedRefund = 70,
  NotPayableRefund = 75,
  ReversedRefund = 80,
  TaxRefund = 85,
  Refund = 100,
  Recollect = 150,
  Default = 200,
  Garnishments = 225,
  Tax = 250,
  TaxPenaltyInterest = 260,
  PrenoteRefund = 265,
  Prenote = 285,
  OverpayRefund = 300
}

export enum NettedCollectionStatus {
  Unknown = 0,
  Collected = 10,
  InTransit = 30,
  PartiallyCollected = 43,
  Ready = 50,
  Returned = 60
}

export enum OutboundFileStatus {
  Unknown = 0,
  FailedToSend = 20,
  Generated = 30,
  Initiated = 40,
  Sent = 50,
  PrintedAndShipped = 60
}

export enum OutboundFileType {
  Unknown = 0,
  AchRefund = 5,
  AdjustmentPositivePay = 7,
  CheckPrint = 10,
  GarnishmentsCheckPrint = 15,
  IsoDebit = 20,
  Nacha = 30,
  PositivePay = 40,
  GarnishmentsPositivePay = 45,
  Prenote = 50
}

export enum RefundPortion {
  Unknown = 0,
  Check = 10,
  DirectDeposit = 20
}

export enum RefundType {
  Unknown = 0,
  Cancel = 10,
  CancelAfterPaid = 15,
  Delete = 20,
  Expired = 23,
  NotPayable = 25,
  Reject = 30,
  Return = 40,
  Reverse = 50,
  Recollect = 60
}

export enum PayStatus {
  Unknown = 0,
  Created = 1,
  Verified = 2,
  Assigned = 3,
  Ignored = 4
}

export enum CheckStatus {
  Unknown = 0,
  Posted = 100,
  NotPosted = 200
}

export enum PayTransactionType {
  Unknown = 0,
  Adjustment = 1,
  Check = 2,
  DirectDepositAdvice = 3,
  ManualAdjustmentToArrearsOrAccruals = 4,
  OpeningBalance = 5,
  PriorQuarterAdjustment = 6,
  TaxReconAdjustment = 7,
  Void = 8
}

export enum CheckAddMode {
  Unknown = 0,
  AdditionalCheck = 1,
  DedNoDirDep = 2,
  CurrentQtrAdj = 3,
  NoDedAllowDirDep = 4,
  FutaCreditReduction = 5,
  NoDedNoDirDep = 6,
  ManualCheck = 7,
  AccrualImport = 8,
  OpeningBalance = 9,
  PriorQtrAdj = 10,
  TaxAdj = 11,
  Regular = 12,
  TaxReconAdj = 13,
  PriorYearAdj = 18,
  GuidedAdj = 20
}

export enum PayPortionState {
  Unknown = 0,
  Unmodified = 10,
  CanceledBeforePaid = 31,
  CanceledAfterPaid = 32,
  CancellationRequested = 33,
  Deleted = 40,
  Rejected = 50,
  Returned = 60,
  Reversed = 70,
  UnsuccessfulReversal = 79,
  NotPayable = 90
}

export enum PayCustomerItemStatus {
  Unknown = 0,
  CollectionCollected = 10,
  CollectionHold = 20,
  CollectionInTransit = 30,
  CollectionPartiallyCollected = 40,
  CollectionPending = 50,
  CollectionReady = 60,
  CollectionReturned = 70,
  CollectionVoided = 80,
  PayCanceledBeforePaid = 90,
  PayCanceledAfterPaid = 91,
  PayStopRequested = 92,
  PayStopInProgress = 93,
  PayCheckPosted = 100,
  PayDeleted = 110,
  PayIgnored = 120,
  PayNotPayable = 130,
  PayRejected = 140,
  PayReturned = 150,
  PayReversed = 160,
  PayUnsuccessfulReversal = 170,
  PayWithCannotPayFlag = 180,
  PaymentGenerating = 190,
  PaymentHold = 200,
  PaymentCheckPaid = 210,
  PaymentDDPaid = 211,
  PaymentProcessingUndoVoid = 220,
  PaymentProcessingVoid = 230,
  PaymentReady = 240,
  PaymentVoided = 250,
  PayrollOpen = 260,
  PayWithCannotCollectFlag = 270,
  StuckInAssembling = 280
}

export enum PayCustomerViewType {
  ViewPays = 0,
  StopPays = 10,
  CancelStop = 20
}

export enum PayCustomerAction {
  Unknown = 0,
  Stop = 10,
  CancelStop = 20
}

export enum PayCustomerActionResultCode {
  Success = 0,
  GeneralFailure = 10,
  PastNachaReversalPeriod = 20,
  DissallowedUndoStopPaymentRequest = 30,
  CheckAlreadyPosted = 40,
  Ignored = 50,
  InvalidActionForStatus = 60,
  CollectionVoided = 70,
  CollectionReturned = 80,
  NotFoundOrInsufficientAccessRights = 90,
  CannotStopZeroAmountPayPortion = 100
}

export enum PaymentType {
  Unknown = 0,
  Check = 10,
  DirectDeposit = 20
}

export enum PaymentStatus {
  Unknown = 0,
  AllLiabilitiesRemoved = 5,
  Created = 10,
  CreatedForHold = 15,
  CreatedForVoid = 16,
  Generating = 18,
  OnHold = 20,
  Paid = 30,
  ProcessingUnVoid = 40,
  ProcessingVoid = 45,
  Ready = 50,
  Voided = 70
}

export enum PayrollInstanceStatus {
  Unknown = 0,
  VerifiedWithCriticalErrors = 10,
  VerifiedWithNotCollectableErrors = 15,
  VerifiedWithNotPayableErrors = 20,
  WaitingForClose = 30,
  Processing = 40,
  Hung = 45,
  Processed = 50,
  Closed = 60
}

export enum PayrollType {
  Unknown = 0,
  Regular = 1,
  OffCycle1 = 2,
  OffCycle2 = 3,
  OffCycle3 = 4,
  OffCycle4 = 5,
  OffCycle5 = 6,
  OffCycle6 = 7,
  OffCycle7 = 8,
  OffCycle8 = 9
}

export enum UserActionType {
  Unknown = 0,
  Continue = 10,
  RequestClose = 20
}

export enum UserActionReason {
  Unknown = 0,
  CloseEventMissing = 100,
  EnvironmentIssuesInUKG = 200,
  EventingDEDNotSetUp = 300,
  EventingDEDSetUpIncorrect = 400,
  MissingOrDeletedPays = 500,
  Other = 600,
  PayrollWasReset = 700
}

export enum PayrollUnitScheduleType {
  Unknown = 0,
  Regular = 1,
  Supplemental = 2,
  Adjustment = 3,
  FutaCredit = 4,
  TaxCredit = 5
}

export enum PayrollUnitFrequency {
  Unknown = 0,
  Biweekly = 1,
  Daily = 2,
  Monthly = 3,
  SemiMonthly = 4,
  Nfl17Weeks = 5,
  Weekly = 6
}

export enum PrintingOption {
  Unknown = 0,
  Default = 100,
  Print = 200,
  Suppress = 300
}

export enum PreliminaryBankTransactionProductType {
  EmployeePay = 500,
  Garnishments = 600,
  Tax = 800
}

export enum PreliminaryBankTransactionType {
  Unknown = 0,
  DirectDeposit = 1,
  Check = 2,
  GarnishmentCheck = 602,
  GarnishmentEft = 611
}

export enum ProductCode {
  All = 0,
  EmployeePay = 500,
  Garnishments = 600,
  Tax = 800,
  Unknown = -1
}

export enum PaymentServicesGatewayProductCode {
  All = 0,
  EmployeePay = 500,
  Garnishments = 600,
  SubmitGarnishments = 700,
  Tax = 800,
  Unknown = -1
}

export enum Operation {
  Unknown = 0,
  Add = 1,
  Update = 2,
  Delete = 3
}

export enum ProductChangeValidationResult {
  Failed = 0,
  PassedWithoutActivationRequested = 1,
  PassedWithActivationRequested = 2
}

export enum ProductConfigurationType {
  Common = 1,
  EmployeePay = 2,
  Garnishments = 600,
  Tax = 800
}

export enum ProviderCode {
  Unknown = 0,
  MasterTax = 801,
  Ute = 802
}

export enum SearchModule {
  EmployeePay = 30,
  File = 50,
  Garnishments = 80,
  CollectionRequests = 100
}

export enum ConnectivityTestOutcome {
  Unknown = 0,
  ConnectionNotResolved = 10,
  ConnectionNotResolvedForReceivedTenant = 20,
  ContractNumberNoMatch = 30,
  MasterCompanyNotFound = 40,
  Success = 50,
  TenantArNumbersDoNotMatch = 55,
  TenantCannotBeResolvedFromHub = 60,
  TenantNotFound = 70
}

export enum PaymentServicesGatewayOutcome {
  Unknown = 0,
  ConnectionNotResolvedForReceivedTenant = 20,
  Success = 50,
  FailedWithException = 51,
  TenantCannotBeResolvedFromHub = 60
}

export enum SyncTenantDataOutcome {
  Unknown = 0,
  CompanySyncNotComplete = 5,
  ConnectionNotResolved = 10,
  ConnectionNotResolvedForReceivedTenant = 20,
  ContractNumberNoMatch = 30,
  MasterCompanyNotFound = 40,
  PayrollUnitSyncNotComplete = 45,
  Success = 50,
  TenantArNumbersDoNotMatch = 55,
  TenantCannotBeResolvedFromHub = 60,
  TenantNotFound = 70
}

export enum SyncGarnishmentsDataOutcome {
  Unknown = 0,
  DedFilterNotCreated = 10,
  LoadNotRequested = 20,
  FailedToReconcile = 30,
  Pending = 40,
  Success = 50
}

export enum ActivationStatus {
  Unknown = 0,
  Activated = 30,
  ClearingSpsTrackingTableFailed = 50,
  ConnectivityTestFailedToInitiate = 100,
  DatabaseExceptionCheckingOpenPayrolls = 200,
  DataSyncUnavailable = 250,
  EnsuringPayrollCodesFailed = 300,
  HasOpenPayrolls = 350,
  Provisioning = 400,
  TenantDistributionFailed = 500,
  TenantNotFound = 550,
  UpdatingCompanySettingsFailed = 600
}

export enum TenantType {
  Unknown = 0,
  CuCustomer = 10,
  UsgInternal = 20
}

export enum CompanyProviderChangeStatus {
  Unknown = 0,
  ProviderChangeSucceeded = 30,
  DatabaseExceptionCheckingOpenPayrolls = 200,
  DatabaseExceptionCheckingConflictingPays = 210,
  DataSyncUnavailable = 250,
  HasOpenPayrolls = 350,
  HasConflictingPays = 360,
  ProviderChangesSuccessful = 375,
  TenantNotFound = 550,
  UpdatingCompanyProviderChangeFailed = 600,
  ValidForPending = 650,
  HasConflictingProviderStartDate = 750,
  HasMigrationDateInPast = 800,
  HasDifferentTaxProvider = 850
}

export enum CompanyNameCheckAppearance {
  Unknown = 0,
  CompanyName = 10,
  DbaName = 20,
  EmptyName = 30
}

export enum CheckAddressWindowOptions {
  None = 0,
  CheckDdaNumber = 10,
  Company = 20,
  DistributionCenter = 30,
  EmployeeNumber = 40,
  Location = 50,
  OrgLevel1 = 60,
  OrgLevel2 = 70,
  OrgLevel3 = 72,
  OrgLevel4 = 74,
  PayGroup = 80
}

export enum TenantStatusCode {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Pending = 3
}

export enum UserManagementAuditActionLevel {
  Create = 10,
  Delete = 20,
  PutEntitlementGroupToUser = 30,
  RemoveEntitlementGroupFromUser = 40
}

export enum UserManagementAuditActionStatus {
  Attempt = 10,
  Completion = 20
}

export enum BankStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2
}

export enum BankInstitution {
  Unknown = 0,
  BankOfAmerica = 2,
  JPMorgan = 5,
  WellsFargo = 10
}

export enum BankAccountPurpose {
  Unknown = 0,
  CheckDisbursement = 10,
  Collection = 20,
  Concentration = 30,
  DdaDisbursement = 40,
  GarnishmentCollection = 420,
  GarnishmentCheckDisbursement = 430,
  GarnishmentEftDisbursement = 440,
  TaxCollection = 520,
  TaxCheckDisbursement = 530,
  TaxEftDisbursement = 540
}

export enum CompanyBrand {
  Unknown = 0,
  KronosSaaShr = 10,
  KronosSaaShrCorporate = 15,
  UkgInc = 20,
  UkgIncCorporate = 25,
  UltimateSoftwareGroup = 30,
  UltimateSoftwareGroupCorporate = 35
}

export enum GarnishmentPayableStatus {
  Unknown = 0,
  NotCollectable = 10,
  NotPayable = 20,
  Payable = 30
}

export enum GarnishmentPaymentType {
  Unknown = 0,
  NotPayable = 1,
  Check = 10,
  Eft = 20
}

export enum GarnishmentStatus {
  Unknown = 0,
  Assigned = 10,
  AssignedToPaymentLiability = 13,
  AssignedToRefundLiability = 14,
  Collected = 15,
  CollectionVoided = 17,
  Excluded = 20,
  Ignored = 30,
  MarkedForRefund = 32,
  MarkedForReplace = 33,
  MarkedForUndo = 35,
  Paid = 40,
  PaymentGenerating = 42,
  ReadyForPayment = 45,
  Refunded = 47,
  Verified = 50
}

export enum GarnishmentType {
  Unknown = 0,
  Bankruptcy = 10,
  ChildSupport = 20,
  Garnishment = 30,
  SpousalSupport = 35,
  StudentLoan = 40,
  TaxLevy = 50
}

export enum ExceptionCode {
  None = 0,
  DuplicateDeduction = 2,
  InvalidEmployeeName = 4,
  InvalidCompanyName = 8,
  InvalidCheckCharacters = 16,
  InvalidFein = 32,
  InvalidSsn = 64,
  MissingCaseNumber = 128,
  ExternalHold = 256,
  MissingCompany = 1024,
  MissingCountyFips = 8192,
  MissingJurisdiction = 65536,
  MissingLegalEntityCompany = 262144,
  MissingMedicalSupportIndicator = 2097152,
  MissingObligation = 8388608,
  MissingPayee = 33554432,
  MissingPayeeAddressLine1 = 134217728,
  MissingPayeeCity = 536870912,
  MissingPayeeCode = 2147483648,
  MissingPayeeName = 8589934592,
  MissingPayeeState = 34359738368,
  MissingPayeeZip = 137438953472,
  MissingPayrollUnit = 1099511627776,
  MissingStateFips = 8796093022208,
  PayrollClosed = 17592186044416,
  RequiresApproval = 35184372088832,
  StandAloneCredit = 70368744177664,
  UnsupportedAmount = 140737488355328,
  UnsupportedJurisdiction = 562949953421312,
  OnHold = 1125899906842624
}

export enum GarnishmentLiabilityStatus {
  Unknown = 0,
  Assembling = 10,
  Assembled = 20,
  Collected = 30,
  Ignored = 38,
  InTransit = 40,
  Ready = 50,
  Returned = 60,
  Voided = 90
}

export enum GarnishmentPaymentLiabilityStatus {
  Unknown = 0,
  Assembled = 10,
  Assembling = 20,
  Assigned = 30,
  Created = 35,
  Paid = 40,
  Ready = 50,
  TotalsCalculated = 60
}

export enum GarnishmentActionType {
  Unknown = 0,
  Canceled = 10,
  Expired = 13,
  Hold = 15,
  Rejected = 20,
  ReleaseHold = 23,
  Returned = 30,
  ReleaseExternalHold = 33,
  UndoCancel = 40,
  UndoCancelAndHold = 42,
  VoidAndReplace = 48,
  Voided = 50
}

export enum GarnishmentRefundLiabilityStatus {
  Unknown = 0,
  Assembling = 10,
  Assembled = 20,
  InTransit = 25,
  Ready = 30,
  Refunded = 40
}

export enum GarnishmentLiabilityType {
  Unknown = 0,
  Payroll = 10,
  Recollect = 20
}

export enum GarnishmentActionReason {
  Unknown = 0,
  CheckStale = 5,
  CustomerError = 10,
  CustomerErrorInternal = 20,
  CustomerRequest = 30,
  CustomerRequestInternal = 40,
  CustomerResearch = 50,
  CustomerResearchInternal = 60,
  CustomerResolvedError = 70,
  CustomerResolvedErrorInternal = 80,
  DamagedCheck = 100,
  DuplicatePayment = 105,
  EmployeeTermed = 110,
  GarnishmentRelease = 130,
  GarnishmentReleaseInternal = 140,
  IncorrectAmount = 160,
  InvalidPayeeInformation = 165,
  MisplacedLost = 200,
  NeverReceived = 300,
  Other = 320,
  PaidByOtherMeans = 340,
  ResearchComplete = 370,
  ResearchCompleteInternal = 380,
  ReturnedMail = 400,
  Stolen = 500
}

export enum TaxPeriodicTaxProcessingStatus {
  Completed = 10,
  Failed = 20,
  Aggregating = 30,
  Mapping = 40,
  MappingFailed = 50,
  CompletedWithoutAggregation = 60
}

export enum TaxExcludedReason {
  ClientNotFound = 10,
  ClientStartDateGreaterThanCheckDate = 20,
  CompanyExcludeFromTaxReporting = 30,
  CompanyNotFound = 40,
  Ignore = 50,
  ImportClientNotFound = 60,
  Inactive = 70,
  InactiveClient = 80,
  InactiveImportClient = 90,
  InvalidTaxCodeFound = 100,
  Missing = 110,
  None = 120,
  NoTaxes = 130,
  NoUteTaxItems = 140,
  Unknown = 150,
  AdjToObPrepaidTransaction = 160,
  OpenBalanceTransaction = 170,
  ReceivedAfterPayrollClosed = 180,
  NoActiveClientsForTenant = 190,
  NonUTEProvider = 200
}

export enum SupportedEmailContentTypes {
  TextPlain = 0,
  TextHtml = 1
}

export enum PayCancelStatus {
  Unknown = 0,
  CancelRequested = 10,
  CanceledByUser = 20,
  PayMarked = 30,
  RequestCompleted = 40,
  RequestedAtBank = 50,
  CanceledBySystem = 60
}

export enum CompanyPrenoteResultStatus {
  Failure = 0,
  AlreadyExists = 1,
  Success = 2,
  Unknown = 3
}


